module.exports = __webpack_public_path__ + "media/images/Twitter_Transparent-c55e0e500368040dd4117d4cc28e28df.png";